import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import RecommendCard from "@/components/cards/RecommendCard";
import { recommendList } from "@/mocks/recommend";

export default function RecommendSection() {
  const items = recommendList.slice(0, 4);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="RECOMMEND"
          title="相关影视推荐"
          description="如果你喜欢「蜜桃成熟时3D」里那份关于成长与等待的细腻表达，这些风格相近的作品或许同样能够打动你。"
          action={
            <Link
              to="/recommend"
              className="flex items-center gap-1 whitespace-nowrap rounded-md border border-primary-300 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
            >
              更多推荐
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          }
        />
        <div className="grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-4">
          {items.map((item) => (
            <RecommendCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}